import MasterInfoFactoryRepositoryImpl from './impl/MasterInfoRepositoryImpl'

export default {
  getInstance () {
    return new MasterInfoFactoryRepositoryImpl()
  }
}
